<div
  #cm
  [id]="'cm-' + id"
  [hidden]="!show"
  class="bfx-context-menu"
  (contextmenu)="hideMenu()"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
  [@showHideMenu]="show ? 'show' : 'hide'"
  (@showHideMenu.start)="showHideMenuStarted($event,cm)"
>
  <ul class="">
    <ng-template let-menuItem ngFor [ngForOf]="menuItems">
      <li
        *ngIf="!isItemSeparator(menuItem)"
        [ngClass]="{ 
          'bfx-context-menu-item-enabled': isItemEnabled(menuItem), 
          'bfx-context-menu-item-disabled': !isItemEnabled(menuItem)
        }"
        (click)="selectedMenuItem(menuItem, $event)"
      >
        <span *ngIf="!isItemSeparator(menuItem)">{{menuItem.title}}</span>
        <i
          *ngIf="menuItem.iconClass && !isItemSeparator(menuItem)"
          class="{{menuItem.iconClass}} bfx-context-menu-arrow"
          aria-hidden="true"
        ></i>
      </li>
      <hr class="bfx-context-menu-hr" *ngIf="isItemSeparator(menuItem)" />
    </ng-template>
  </ul>
</div>
